// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fe5a28b3","952":"2b5c6a96"}[chunkId] + ".chunk.js";
};